<template>
    <div>
        <div id="content-main ms-font-m">
            <div class="padding ms-font-m">

                <br />

                <div style="text-align:center">
                    <img src="../../Images/logo.png" />
                </div>

                <br />

                <!--<div class="ms-Grid-row">
        <div class="ms-Grid-col ms-u-lg12">
            <input v-model="login" id="name" type="text" style="width: 100%;" class="textBoxRound" placeholder="Логин" />
        </div>
    </div>

    <div class="ms-Grid-row">
        <div class="ms-Grid-col ms-u-lg12">
            <input v-model="pass" id="name" type="text" style="width: 100%;" class="textBoxRound" placeholder="Пароль" />
        </div>
    </div>

    <div style="text-align: center; width: 100%">
        <button class="button" id="signid-button" v-on:click="Notify('Test', 'Test2')" style="margin:0 auto">Войти</button>
    </div>

    <br />-->

                <div style="text-align: center; width: 100%">
                    <button class="button" id="signid-button" v-on:click="SighIn()" style="margin:0 auto">Войти с помощью IPChainID</button>
                </div>
                <div style="text-align: center; width: 100%">
                    <span>Электронное депонирование и фиксация сведений в распределенном реестре — наиболее простой и эффективный способ обеспечить себя доказательствами своего авторства.</span>
                    <a href="https://nris.ru/deposits/">Подробнее о n'RIS</a>
                    <a style="display: block;" href="https://auth.nris.ru/registration">Зарегистрироватся</a>
                </div>
            </div>
        </div>
        <!--<notifications group="foo" />-->
    </div>
</template>

<script>
    //import $ from 'jquery'
    import AuthSvc from '../classes/AuthSvc';
    import NotificationsSvc from '../../src/classes/NotificationsSvcT'

    export default {
        data() {
            return {
                login: null,
                pass: null
            }
        },
        methods: {
            SighIn() {
                //debugger;
                //window.Office.context.run(function (context) {

                //    debugger;
                //    var properties = context.document.properties;
                //    var customProperties = properties.customProperties;
                //    context.load(properties);
                //    context.load(customProperties);

                //    return context.sync().then(function () {
                //        var managedMetadataProperty = customProperties.getItem('MngdMetadata');
                //        properties.title = properties.title + " Additional Title Text"; // once the sync goes off, this works.
                //        context.load(managedMetadataProperty);
                //        return context.sync().then(function () {
                //            console.log(managedMetadataProperty.value) // let's say this looks like "10;#Label 1|64d2cd3d-57d4-4c23-9603-866d54ee74f1"
                //            managedMetadataProperty.value = "11;#Label 2|cc3d57d4-4c23-72d4-3031-238b9100f52g"
                //            return context.sync();  // now the value in the javascript object for managedMetadataProperty is updated, but the value in the document does not change. 
                //        });
                //    });
                //});

                //AuthSvc.Notify();
                process.env.ROOT_API
                AuthSvc.SighIn();
                //NotificationsSvc.Notify('rewrewr', 'erewrwer');
            },
            Notify(header, text) {
                this.$notify({
                    group: 'foo',
                    title: header,
                    text: text
                });
            }
        },
        mounted: function () {
            console.log("Env vars: " + JSON.stringify(process.env))
            console.log("Api var: " + process.env.VUE_APP_ROOT_API)
            console.log("WSS var: " + process.env.VUE_APP_WSS)
            console.log("REDIRECT_URI var: " + process.env.VUE_APP_REDIRECT_URI)
            AuthSvc.Init();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import '../../Content/Home.css';
    @import '../../Content/fabric.css';
    @import '../../Content/fabric.components.css';
    @import '../../Content/fabric.rtl.css';
</style>

